






























































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { scheduleSeasonFields } from '@/config/schedule-config';
import BpcInput from '@shared/components/forms/inputs/input/input.vue';
import BpcSelect from '@shared/components/forms/inputs/select/select.vue';
import BpcEntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import BpcSection from '@shared/components/forms/inputs/section/section.vue';
import { Schedule, ScheduleSeason, ScheduleSeasonErrorObject } from '@bookings/interfaces/schedule';
import BpcDatePicker from '@shared/components/forms/inputs/datepicker/datepicker.vue';
import BpcScheduleSlotsForm from './schedule-slots-form.vue';
import ScheduleService, { useScheduleService } from '@bookings/services/schedule-service';
import BpcScheduleSlotRangeGroupedForm from './schedule-slot-range-grouped-form.vue';

@Component({
  name: 'bpc-schedule-season-form',
  components: {
    BpcInput,
    BpcSelect,
    BpcEntitySelect,
    BpcSection,
    BpcDatePicker,
    BpcScheduleSlotsForm,
    BpcScheduleSlotRangeGroupedForm,
  },
})
export default class ScheduleSeasonForm extends Vue {
  @Prop(Object) readonly value: ScheduleSeason;
  @Prop({
    type: Object,
  })
  readonly schedule: Schedule;
  @Prop({
    type: Number,
  })
  readonly scheduleSeasonId: number;

  loading = false;
  errorsObject: ScheduleSeasonErrorObject = {};
  srv: ScheduleService = null;

  get formModel() {
    return this.value;
  }

  set formModel(value: ScheduleSeason) {
    this.$emit('input', value);
  }

  get fieldsConfig() {
    return scheduleSeasonFields;
  }

  created() {
    this.srv = useScheduleService();
  }

  mounted() {
    this.getScheduleSeason();
  }

  async getScheduleSeason() {
    if (!this.scheduleSeasonId) {
      return;
    }
    if (!this.schedule) {
      throw new Error('Schedule is required');
    }
    this.formModel = await this.srv.getScheduleSeason(this.schedule.id, this.scheduleSeasonId);
    this.loading = false;
  }
  manageSaveErrors(errors: any) {
    this.errorsObject = {};
    Object.keys(errors).forEach(key => {
      this.$set(this.errorsObject, key, { error: errors[key][0], state: false });
    });
  }
}
